import { fetchGet } from './api';
import { IPartnership } from '../types/partnership.type';

export const fetchPartnerships = () => fetchGet<IPartnership[]>('partnerships');
